import makeApiRequest from '../../../api/makeApiRequest';

const onlineStatus = {
  name: 'onlineStatus',
  state: [],
  reducers: {
    onLoaded(state, { data }) {
      if (data.length) {
        return data.map(c => {
          const isPhysician = !!c.attributes.physician;
          return {
            userId: isPhysician ? c.attributes.physician.id : c.attributes.patient.id,
            isOnline: !!c.attributes.online,
          };
        });
      }
      return [...state];
    },
  },
  effects() {
    return {
      async load(_, { oidcSession }) {
        const [request] = makeApiRequest('/contacts', oidcSession);

        const { error, data } = await request;

        if (!error) return this.onLoaded(data);
        throw error;
      },
    };
  },
};

export default onlineStatus;
